// PRAT-79: o CVV do cartão salvo vai no corpo do place-order. Nada que sai do
// app (console, Sentry Replay com networkCaptureBodies) pode levar esse valor.
const SECRET_KEY = /cvv|csc/i;
const SECRET_IN_JSON = /("[^"]*(?:cvv|csc)[^"]*"\s*:\s*)"[^"]*"/gi;
const FILTERED = '[Filtered]';

/**
 * Devolve uma cópia de `value` com qualquer campo de CVV trocado por
 * `[Filtered]`. Aceita objeto, array ou string JSON. Não altera o original.
 */
export function redactCardSecrets<T>(value: T): T {
  return redact(value, 0) as T;
}

function redact(value: unknown, depth: number): unknown {
  if (depth > 12) return value;
  if (typeof value === 'string') {
    return SECRET_KEY.test(value) ? value.replace(SECRET_IN_JSON, `$1"${FILTERED}"`) : value;
  }
  if (Array.isArray(value)) return value.map(item => redact(item, depth + 1));
  if (value && typeof value === 'object') {
    const out: Record<string, unknown> = {};
    for (const [key, item] of Object.entries(value)) {
      out[key] = SECRET_KEY.test(key) && item != null ? FILTERED : redact(item, depth + 1);
    }
    return out;
  }
  return value;
}
